import React, { useEffect, useRef } from 'react';
import moment from 'moment';

import Header from '../components/Header/Header';
import Filter from './Filter';
import Table from './Table';
import { useCaseListFilter as useFilter } from 'modules/cases/hooks/useCaseListFilter';
import { useReports } from 'modules/reports/hooks/useReports';
import { useAccounts } from 'hooks/useAccounts';
import Total from './Total';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { useCaseReportFilter } from '../hooks/useReportFilterRetain';

const reportType = 'trust_account_transaction_report';

export default function TrustAccountTransactionReport() {
  const userContext = useUserDetailsContext();
  const { report_start, report_end, retain_filters, ...restFilterPrefs } =
    userContext?.firmDetails?.user_preferences?.filters?.report?.[reportType] || {};
  const isFirstRender = useRef(true);

  const { accountList, isAccountsLoading } = useAccounts({ excludeFromLoading: true });
  const accList = accountList?.filter((v) => v.account_type !== 'operating');
  const { filter, filterOnChange, refreshList, applyFilter } = useFilter({
    report_end: retain_filters ? new Date(report_end) : moment().toDate(),
    report_start: retain_filters ? new Date(report_start) : moment().subtract(30, 'days').toDate(),
    ...(retain_filters ? restFilterPrefs : {}),
  });
  const { loadReportList, list, totals, pageSize, paginatorTemplate, reportExport } = useReports({
    type: reportType,
    _filter: filter,
  });
  const { handleFilterUpdate } = useCaseReportFilter(filter, userContext, reportType);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    handleFilterUpdate();
  }, [filter]);
  useEffect(() => {
    const params = {
      ...filter,
      account_list: accList && accList.length > 1 ? '' : accList.map((m) => m.account_id)[0],
    };
    applyFilter(params);
  }, [accountList]);

  useEffect(() => {
    if (filter?.account_list?.length && accList?.length === 1) {
      handleRun();
    }
  }, [filter]);

  const handleRun = () => {
    loadReportList({
      type: reportType,
      filter,
    });
  };

  const handleExport = () => {
    reportExport({ filter });
  };

  useEffect(() => {
    loadReportList({ filter });
  }, []);

  const resetReportFilter = () => {
    refreshList({ report_end: moment().toDate(), report_start: moment().subtract(30, 'days').toDate() });
    loadReportList({
      type: reportType,
      filter: {
        report_end: moment().toDate(),
        report_start: moment().subtract(30, 'days').toDate(),
      },
    });
  };

  return (
    <div className="datatable-responsive card-bg  p-3 mb-3">
      <Header title="Trust Account Transactions Report" handleRun={handleRun} handleExport={handleExport} />
      <Filter {...{ filter, filterOnChange, resetReportFilter, accList, isAccountsLoading, userContext, handleFilterUpdate, reportType }} />
      <Total {...totals} />
      <Table {...{ ...totals, paginatorTemplate, list, pageLimit: pageSize }} />
    </div>
  );
}
